/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

(() => {'use strict';
 function enText(pl,en){return /^en(?:-|$)/i.test(document.documentElement.lang||'')?en:pl;}
 if ('serviceWorker' in navigator && !/^\/(?:_admin|narzedzia|wycieczki)(?:\/|$)/.test(location.pathname)) {
  // Keep the promise available for push, but register after initial loading.
  // Worker installation and precache must not compete with the first paint.
  window.pewniakiSW=new Promise((resolve,reject)=>{
   const register=()=>navigator.serviceWorker.register('/sw.js',{scope:'/',updateViaCache:'none'}).then(resolve,reject);
   const idle=()=>('requestIdleCallback' in window?requestIdleCallback(register,{timeout:2000}):setTimeout(register,0));
   if(document.readyState==='complete')idle();else window.addEventListener('load',idle,{once:true});
  });
  window.pewniakiSW.catch(()=>{});
 }
 function banner(force=false,created=''){
  let el=document.getElementById('offline-banner');
  if(force||!navigator.onLine){
   if(!el){el=document.createElement('div');el.id='offline-banner';el.setAttribute('role','status');document.body.prepend(el);}
   if(force)el.setAttribute('data-pwa-cached','true');
   if(!el.textContent){el.textContent=jst("pwa_register_js.a902c7704c97")+(created?new Date(created).toLocaleString(jst("pwa_register_js.02270bd2e2dd"))+' ':'');const a=document.createElement('a');a.href=jst("pwa_register_js.1a7174732596");a.textContent=jst("pwa_register_js.f24e1790ac65");el.append(a);}
  }else if(!el?.hasAttribute('data-pwa-cached'))el?.remove();
 }
 navigator.serviceWorker?.addEventListener('message',e=>{if(e.data?.type==='pwa-cached')banner(true,e.data.created);});
 window.addEventListener('online',()=>banner());window.addEventListener('offline',()=>banner());banner();
})();
